import { call, put, takeEvery } from 'redux-saga/effects';
import {
    GET_COUPON_LIST_FAILED,GET_COUPON_LIST_REQUESTED, GET_COUPON_LIST_SUCCESS, GET_APPLY_COUPON_FAILED, GET_APPLY_COUPON_REQUESTED, GET_APPLY_COUPON_SUCCESS, GET_APPLY_COUPON_RENTAL_FAILED, GET_APPLY_COUPON_RENTAL_REQUESTED, GET_APPLY_COUPON_RENTAL_SUCCESS
} from 'resources/actionTypes';
import { couponList, couponApply, couponApplyRental } from 'services/CouponService';
import store from "redux/store";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchCouponList(action) {
  const payload = action.payload || {};
  const couponListData = yield call(couponList,
    payload.userCouponList
  );
  if (couponListData?.success) {
    yield put({
      type: GET_COUPON_LIST_SUCCESS,
      couponListData: couponListData,
    });
    toast.success(couponListData.message);
  } else {
    yield put({
      type: GET_COUPON_LIST_FAILED,
      message: couponListData.message,
    });
      toast.error(couponListData.message || 'Coupon List failed');
  }
}
export function* couponListSaga() {
  yield takeEvery(GET_COUPON_LIST_REQUESTED, fetchCouponList);
}

function* postApplyCoupon(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const couponApplyData = yield call(couponApply,
    payload.postCouponData?.payloadData
  );
  if (couponApplyData?.success) {
    yield put({
      type: GET_APPLY_COUPON_SUCCESS,
      couponApplyData: couponApplyData,
    });
    toast.success(couponApplyData.message);
    if(payload?.postCouponData?.actionName !== "remove"){
      payload.setCardModel();
    }
  } else {
    yield put({
      type: GET_APPLY_COUPON_FAILED,
      message: couponApplyData.message,
    });
      toast.error(couponApplyData.message || 'Adding Coupon failed');
  }
  store.dispatch(onLoaderTrigger(false));
}
export function* applyCouponSaga() {
  yield takeEvery(GET_APPLY_COUPON_REQUESTED, postApplyCoupon);
}

function* postApplyCouponRental(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const couponRentalData = yield call(couponApplyRental,
    payload?.postCouponRentalData?.payloadData    
  );
  if (couponRentalData?.success) {
    yield put({
      type: GET_APPLY_COUPON_RENTAL_SUCCESS,
      couponRentalData: couponRentalData,
    });
    toast.success(couponRentalData.message);
    if(payload?.postCouponRentalData?.actionName !== "remove"){
      payload.setCardModel();
    }
  } else {
    yield put({
      type: GET_APPLY_COUPON_RENTAL_FAILED,
      message: couponRentalData.message,
    });
      toast.error(couponRentalData.message || 'Adding Coupon failed');
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* applyRentalCouponSaga() {
  yield takeEvery(GET_APPLY_COUPON_RENTAL_REQUESTED, postApplyCouponRental);
}

